import Black from '@/assets/titanbet/fonts/Roboto-Black.ttf';
import BlackItalic from '@/assets/titanbet/fonts/Roboto-BlackItalic.ttf';
import Bold from '@/assets/titanbet/fonts/Roboto-Bold.ttf';
import BoldItalic from '@/assets/titanbet/fonts/Roboto-BoldItalic.ttf';
import ExtraLight from '@/assets/titanbet/fonts/Roboto-Thin.ttf';
import ExtraLightItalic from '@/assets/titanbet/fonts/Roboto-ThinItalic.ttf';
import Light from '@/assets/titanbet/fonts/Roboto-Light.ttf';
import LightItalic from '@/assets/titanbet/fonts/Roboto-LightItalic.ttf';
import Regular from '@/assets/titanbet/fonts/Roboto-Regular.ttf';
import Italic from '@/assets/titanbet/fonts/Roboto-Italic.ttf';
import SemiBold from '@/assets/titanbet/fonts/Roboto-Medium.ttf';
import SemiBoldItalic from '@/assets/titanbet/fonts/Roboto-MediumItalic.ttf';

import MerriweatherBlack from '@/assets/titanbet/fonts/Merriweather-Black.ttf';
import SilvanoWesternRegular from '@/assets/titanbet/fonts/SilvanoWestern-Regular.otf';

export const fontFace = `
      @font-face {
          font-family: 'SilvanoWestern';
          font-style: normal;
          font-weight: 400;
          font-display: swap;
          src: url('${SilvanoWesternRegular}') format('opentype');
        }

        @font-face {
          font-family: 'Merriweather';
          font-style: normal;
          font-weight: 400;
          font-display: swap;
          src: url('${MerriweatherBlack}') format('opentype');
        }
        
        @font-face {
          font-family: 'roboto';
          font-style: normal;
          font-weight: 100;
          font-display: swap;
          src: url('${ExtraLight}') format('opentype');
        }
        @font-face {
          font-family: 'roboto';
          font-style: italic;
          font-weight: 100;
          font-display: swap;
          src: url('${ExtraLightItalic}') format('opentype');
        }
      
        @font-face {
          font-family: 'roboto';
          font-style: normal;
          font-weight: 300;
          font-display: swap;
          src: url('${Light}') format('opentype');
        }
        @font-face {
          font-family: 'roboto';
          font-style: italic;
          font-weight: 300;
          font-display: swap;
          src: url('${LightItalic}') format('opentype');
        }
      
        @font-face {
          font-family: 'roboto';
          font-style: normal;
          font-weight: 400;
          font-display: swap;
          src: url('${Regular}') format('opentype');
        }
        @font-face {
          font-family: 'roboto';
          font-style: italic;
          font-weight: 400;
          font-display: swap;
          src: url('${Italic}') format('opentype');
        }
      
        @font-face {
          font-family: 'roboto';
          font-style: normal;
          font-weight: 500;
          font-display: swap;
          src: url('${SemiBold}') format('opentype');
        }
        @font-face {
          font-family: 'roboto';
          font-style: italic;
          font-weight: 500;
          font-display: swap;
          src: url('${SemiBoldItalic}') format('opentype');
        }
      
        @font-face {
          font-family: 'roboto';
          font-style: normal;
          font-weight: 700;
          font-display: swap;
          src: url('${Bold}') format('opentype');
        }
        @font-face {
          font-family: 'roboto';
          font-style: italic;
          font-weight: 700;
          font-display: swap;
          src: url('${BoldItalic}') format('opentype');
        }
      
        @font-face {
          font-family: 'roboto';
          font-style: normal;
          font-weight: 900;
          font-display: swap;
          src: url('${Black}') format('opentype');
        }
        @font-face {
          font-family: 'roboto';
          font-style: italic;
          font-weight: 900;
          font-display: swap;
          src: url('${BlackItalic}') format('opentype');
        }
      `;
